
<template>

  <div class="ui text container">
    <div class="ui segments">

      <!-- Website logo -->
      <div class="ui segment">
        <a href="/">
          <img width="75%" class="ui centered image" src="@/assets/images/7asanat-logo.png" />
        </a>
      </div>

      <Counter v-if="khatma.progress >= 0" :khatma="khatma" :displayEhdaa="true" />

      <div class="ui almarai center aligned grey header" :class="[!isMobile() ? 'small' : 'mini']">
        <div class="content">

          يمكنك
          <span class="ui primary text">اختيار أرباع أحزاب متعددة</span>
          (متصلة أو متفرقة)

          <br><br>

          بعد المشاركة يمكنك
          <span class="ui primary text">عرض الآيات المطلوبة للقراءة</span>

        </div>
      </div>

      <!-- Display mode menu -->
      <div class="ui display segment">

        <h4 class="ui almarai center aligned grey header">طريقة العرض:</h4>

        <div class="ui almarai large primary two item menu">

          <a class="item" :class="[displayMode === 'general' && 'active']"
            @click="setDisplayMode('general')">أرقام أرباع الأحزاب</a>

          <a class="item" :class="[displayMode === 'detailed' && 'active']"
            @click="setDisplayMode('detailed')">تفاصيل أرباع الأحزاب</a>

        </div>

      </div>

      <!-- General display -->
      <div v-if="displayMode === 'general'" class="ui segment">
        <div class="ui almarai vertically divided grid">

          <div v-for="part in 30" :key="part" class="row">

            <div class="sixteen wide center aligned column">
              <h4 class="ui grey header">الجزء {{ partNames[part - 1] }}</h4>
            </div>

            <QuarterBlock v-for="quarter in khatma.quarters.slice((part - 1) * 8, (part - 1) * 8 + 8)"
              :key="quarter.id" :quarter="quarter"
              @select-quarter="selectQuarter(quarter.id)" />

          </div>

        </div>
      </div>

      <!-- Detailed display -->
      <table v-else class="ui almarai structured unstackable single line selectable table" :class="[isMobile() && 'tiny']">

        <thead>
          <tr>
            <th class="center aligned">الجزء</th>
            <th class="right aligned">ربع الحزب</th>
            <th class="right aligned">الآيات</th>
            <th class="center aligned">الصفحات</th>
          </tr>
        </thead>

        <QuarterRow v-for="quarter in khatma.quarters" :key="quarter.id"
          :quarter="quarter" @click.native="selectQuarter(quarter.id)" />

      </table>

      <Participation :khatma="khatma" :quarters="selectedQuarters" />

    </div>
  </div>

</template>

<script>
import axios from 'axios';

import Counter from '@/components/Khatmat/Counter';

import QuarterBlock from '@/components/Khatmat/QuarterBlock';
import QuarterRow from '@/components/Khatmat/QuarterRow';

import Participation from '@/components/Khatmat/Participation';

export default {

  name: 'Khatma',
  components: {

    Counter,

    QuarterBlock,
    QuarterRow,

    Participation

  },
  data: () => ({

    khatma: {

      quarters: []

    },

    displayMode: 'general',

    partNames: [

      'الأول',
      'الثاني',
      'الثالث',
      'الرابع',
      'الخامس',
      'السادس',
      'السابع',
      'الثامن',
      'التاسع',
      'العاشر',
      'الحادي عشر',
      'الثاني عشر',
      'الثالث عشر',
      'الرابع عشر',
      'الخامس عشر',
      'السادس عشر',
      'السابع عشر',
      'الثامن عشر',
      'التاسع عشر',
      'العشرون',
      'الحادي والعشرون',
      'الثاني والعشرون',
      'الثالث والعشرون',
      'الرابع والعشرون',
      'الخامس والعشرون',
      'السادس والعشرون',
      'السابع والعشرون',
      'الثامن والعشرون',
      'التاسع والعشرون',
      'الثلاثون'

    ]

  }),
  computed: {

    selectedQuarters() {

      return this.khatma.quarters.filter((quarter) => quarter.status === 'reserved');

    }

  },
  async mounted() {

    // Get khatma quarters
    try {

      // Get khatma
      const result = await axios.get(`${process.env.VUE_APP_BASE_URL}/khatmat/${this.$route.params.id}`);
      this.khatma = result.data;

      document.title = `ختمة قرآنية - ${this.khatma.ehdaa}`;

      // Join khatma room
      this.$socket.emit('join', this.khatma.id);

    } catch (err) {

      if (err.response.status === 404) {

        alert('هذه الختمة غير موجودة');
        window.location = '/';

      }

      else if (err.response.status === 400) {

        alert('هذه الختمة منتهية');
        window.location = '/';

      }

      else
        alert(err);

    }

    // Display mode
    if (!localStorage.getItem('displayMode'))
      localStorage.setItem('displayMode', 'general');

    this.displayMode = localStorage.getItem('displayMode');

  },
  methods: {

    setDisplayMode(displayMode) {

      this.displayMode = displayMode;
      localStorage.setItem('displayMode', displayMode);

    },

    selectQuarter(quarterID) {

      const quarter = this.khatma.quarters.find((quarter) => quarter.id === quarterID);

      if (quarter.status === 'available') {

        this.$socket.emit('reserve', quarterID);
        quarter.status = 'reserved';

      } else {

        this.$socket.emit('release', quarterID);
        quarter.status = 'available';

      }

    },

    blockQuarter(quarterID) {

      const quarter = this.khatma.quarters.find((quarter) => quarter.id === quarterID);
      quarter.status = 'taken';

    },

    releaseQuarter(quarterID) {

      const quarter = this.khatma.quarters.find((quarter) => quarter.id === quarterID);
      quarter.status = 'available';

    }

  },
  sockets: {

    khatma(newKhatma) {

      if (!newKhatma) {

        window.location = '/';

      } else if (newKhatma.concluded) {

        alert('انتهت هذه الختمة');
        window.location = '/';

      } else {

        this.khatma.ehdaa = newKhatma.ehdaa;
        this.khatma.progress = newKhatma.progress;

      }

    },

    reserve(quarterID) {

      this.blockQuarter(quarterID);

    },

    release(quarterID) {

      this.releaseQuarter(quarterID);

    },

    currentKhatmaCompleted() {

      alert('اكتملت الختمة الحالية. بإمكانك المشاركة في الختمة الجديدة');
      window.location.reload();

    },

    error(err) {

      if (err.tag === 'err')
        alert('Server error');

    }

  }

}
</script>

<style lang="scss" scoped>
.ui.menu .item {
  color: #767676;
}

.vertically.divided.grid .row {
  padding-bottom: 0;
}
.vertically.divided.grid .column {
  margin-top: 0;
}

table {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.display.segment {
  position: sticky !important;
  z-index: 1;
  bottom: -100px;
}

thead th {
  position: sticky !important;
  top: 104px;
}
</style>
